import { cls } from "@fvilers/cls";
import { ComponentProps } from "react";
import styles from "./DataTableButton.module.css";

type DataTableButtonProps = {
  variant?: "accent-2" | "neutral";
} & ComponentProps<"button">;

export function DataTableButton({
  className,
  variant = "neutral",
  ...props
}: DataTableButtonProps) {
  return (
    <button
      className={cls(
        styles.DataTableButton,
        styles[`color-${variant}`],
        className,
      )}
      type="button"
      {...props}
    />
  );
}
